import { useState } from "react";
import CorporateLeadsTable from "./corporateLeadsTable";

const ITEMS_PER_PAGE = 50;

const RenderTabContent = ({ activeData, handleActionClick, activeTab, handleCommentSave }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const filteredData =
    activeData?.filter((item) =>
      item.companyName?.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div>
      <div className="mb-3 row align-items-center">
        <div className="col-md-9">
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search by Company Name"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        <div className="col-md-3 text-end">
          {totalPages > 1 && (
            <ul className="pagination pagination-sm justify-content-end mb-0">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Prev
                </button>
              </li>
              {Array.from({ length: totalPages }, (_, i) => (
                <li
                  key={i}
                  className={`page-item ${
                    currentPage === i + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>
      <CorporateLeadsTable leads={paginatedData} handleActionClick={handleActionClick} activeTab={activeTab} handleCommentSave={handleCommentSave} />
    </div>
  );
};

export default RenderTabContent;
